<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">

        <div class="card">
          <div class="card-header">
            <h5>Пользователи
              <button class="btn btn-success pull-right" @click="mixinGoToRouter('settingsAccessUsersEdit',{id:'new'})">Новый пользователь</button>
            </h5>
          </div>
          <div class="card-body">
            <form @submit.prevent="searchUser">
              <div class="flex">
                <input required placeholder="Текст для поиска" v-model="searchText" type="text" class="form-control mr-2">
                <button @click="getUsers" type="button" class="btn btn-default mr-2">Сбросить</button>
                <button type="submit" class="btn btn-info">Поиск</button>
              </div>
            </form>
          </div>
        </div>

        <div>
          <pulse-loader :loading="loading" :color="loadingColor" style="text-align: center"/>
        </div>

        <div class="card" v-if="!loading">
          <div class="card-body">
            <table class="table table-hover table-sm">
              <thead>
              <tr>
                <th></th>
                <th>ID</th>
                <th>Имя</th>
                <th>Логин</th>
                <th>Тип пользователя</th>
                <th>Дата создания</th>
                <th>Дата редактирования</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(record, index) in records">
                <td>{{(index + 1) + (paginator ? ((paginator.current_page - 1) * paginator.per_page) : 0)}}</td>
                <td>{{record.id}}</td>
                <td>{{record.name}}</td>
                <td>{{record.login}}</td>
                <td>{{ getRoles(record.roles)}}</td>
                <td>{{record.created_at}}</td>
                <td>{{record.updated_at}}</td>
                <td><a @click="mixinGoToRouter('settingsAccessUsersEdit',{id:record.id})" class="btn btn-sm btn-info">Редактировать</a></td>
              </tr>
              </tbody>
            </table>

            <div class="text-right">
              <paginate v-if="paginator"
                        v-model="paginator.current_page"
                        :page-count="paginator.last_page"
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="getUsers"
                        :prev-text="'&laquo'"
                        :next-text="'&raquo'"
                        :container-class="'pagination'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :active-class="'active green_btn'">
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .text-rigth {
    padding-right: 10px;
  }

  .pagination {
    justify-content: flex-end;
  }

  a.btn {
    cursor: pointer;
    color: white;
  }

  a.btn:hover {
    color: white;
  }

</style>

<script>

  import api from '@/api'
  import Paginate from 'vuejs-paginate'

  export default {
    components: {
      Paginate,
    },
    data() {
      return {
        records: null,
        searchText: null,
        paginator: null,
        loading: false,
        loadingColor: this.$constants.LOADING_COLOR,
      }
    },
    mounted() {
      this.getUsers()
    },
    methods: {
      async searchUser() {
        this.loading = true;
        let {data} = await api.index('/users/getUsers?search=' + this.searchText);
        if (data.success){
          this.paginator = null;
          this.records = data.records;
        }
        this.loading = false;
      },
      editUser(id) {
        this.mixinGoToRouter('settingsAccessUsersEdit', id)
      },
      getRoles(roles) {
        if (!roles) return
        let keys = Object.keys(roles)
        let role = ''
        keys.forEach((key) => {
          if (key > 0) role += ", ";
          role += roles[key].name_title
        });
        return role
      },
      async getUsers(page = null) {
        this.loading = true;
        let {data: r_data} = await api.index('/users/getUsers?page=' + page)
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.records = data
        this.loading = false;
      }
    }
  }

</script>
